export default __webpack_public_path__ + "static/3_35-178f650ccabce5ce5e9c10c7a6499398.png";